import { User } from "../domain/User";
import { UserRepo, CreateUserData, UpdateUserData, CreateUserResult } from "../domain/UserRepo";
import { client, query_dispatcher } from "@/api/client";
import { Store } from "vuex";

export class APIUserRepo implements UserRepo {
  private store: Store<any>;

  constructor(store: Store<any>) {
    this.store = store;
  }

  async find_all(): Promise<User[]> {
    try {
      // Obtener el user_id del usuario actual desde el store
      const currentUser = this.store.getters['me/userData'];
      const userId = currentUser?.id;

      if (!userId) {
        return [];
      }
      const router = require('@/router').default;
      const companyId = router.currentRoute?.params?.companydb_id ?
        parseInt(router.currentRoute.params.companydb_id) : (currentUser?.company_id ? parseInt(currentUser.company_id) : null);

      const response = await query_dispatcher.dispatch('get_workers.query', {
        user_id: userId,
        company_id: companyId
      });

      return response.map((userData: any): User => new User(
        userData.id,
        userData.username,
        userData.email || "",
        userData.user_type || 'worker',
        userData.friendship_kind,
        userData.is_active !== false, // Por defecto true
        userData.friendship_kind === 'propietario',
        userData.estado || 'activo',
        userData.first_name,
        userData.last_name
      ));
    } catch (error) {
      throw error;
    }
  }

  async find_by_id(id: string): Promise<User | null> {
    try {
      const users = await this.find_all();
      const user = users.find(u => u.id.toString() === id);
      return user || null;
    } catch (error) {
      return null;
    }
  }

  async create(userData: CreateUserData): Promise<CreateUserResult> {
    try {
      const response = await client.post('create_companydb_user/', {
        username: userData.username,
        email: userData.email,
        password: userData.password,
        companyDB: userData.companydb_id,
        friendship_kind: 'employee',
        role_kind: 'writer',
        view_all_companies: false,
        default_role_kind: null,
        view_invoices: false,
        view_banks: false,
        view_e_invoice: false,
        view_gestor: false,
        view_working_hours: userData.view_working_hours !== false,
      });

      if (response.data.error) {
        return { error: response.data.error };
      }

      const userId = response.data.user_id || response.data.id || response.data.user?.id;

      return {
        user_id: userId
      };
    } catch (error: any) {
      return { error: error.message || 'Error al crear usuario' };
    }
  }

  async update(userId: number, userData: UpdateUserData): Promise<{ error?: string }> {
    try {
      const requestData: any = {
        user_id: userId,
        email: userData.email,
        friendship_kind: userData.friendship_kind,
        companydb_id: userData.companydb_id,
        view_working_hours: userData.view_working_hours !== false,
      };

      const response = await client.put('update_companydb_user/', requestData);

      if (response.data.error) {
        return { error: response.data.error };
      }

      return {};
    } catch (error: any) {
      return { error: error.message || 'Error al actualizar usuario' };
    }
  }

  async toggleActive(userId: number, isActive: boolean, companydb_id?: number): Promise<{ status: string; message?: string }> {
    try {
      const response = await client.put('update_companydb_user/', {
        user_id: userId,
        is_active: isActive,
        email: '', // email vacío para no modificarlo
        companydb_id: companydb_id,
      });

      if (response.data.error) {
        return {
          status: 'error',
          message: response.data.error
        };
      }

      return {
        status: 'ok',
        message: `Usuario ${isActive ? 'activado' : 'desactivado'} correctamente`
      };
    } catch (error: any) {
      return {
        status: 'error',
        message: error.message || 'Error al cambiar estado del usuario'
      };
    }
  }
}